import { useState, useEffect, useCallback } from "react";
import { translate } from "../../localization/translateService";

const KEYS = {
  title: "SHORTS.LISTING.TITLE",
  subtitle: "SHORTS.LISTING.SUBTITLE",
  heroTitleL1: "SHORTS.LISTING.HERO_TITLE_1",
  heroTitleL2: "SHORTS.LISTING.HERO_TITLE_2",
  explore: "SHORTS.LISTING.EXPLORE",
  featured: "SHORTS.LISTING.FEATURED",
  views: "SHORTS.LISTING.VIEWS",
  empty: "SHORTS.LISTING.EMPTY",
  error: "SHORTS.LISTING.ERROR",
  retry: "SHORTS.LISTING.RETRY",
  end: "SHORTS.LISTING.END",
  exit: "SHORTS.VIEWER.EXIT",
  muted: "SHORTS.VIEWER.MUTED",
  sound: "SHORTS.VIEWER.SOUND",
  share: "SHORTS.VIEWER.SHARE",
  seeMore: "SHORTS.VIEWER.SEE_MORE",
  collapse: "SHORTS.VIEWER.COLLAPSE",
  videoError: "SHORTS.VIEWER.VIDEO_ERROR",
  stillWatching: "SHORTS.VIEWER.STILL_WATCHING",
  continueWatching: "SHORTS.VIEWER.CONTINUE_WATCHING",
  copied: "SHORTS.VIEWER.COPIED",
  close: "SHORTS.VIEWER.CLOSE",
  prev: "SHORTS.VIEWER.PREV",
  next: "SHORTS.VIEWER.NEXT",
  loginTitle: "SHORTS.VIEWER.LOGIN_TITLE",
  loginDesc: "SHORTS.VIEWER.LOGIN_DESC",
  loginLater: "SHORTS.VIEWER.LOGIN_LATER",
  loginNow: "SHORTS.VIEWER.LOGIN_NOW",
};

const DEFAULTS = {
  title: "Shorts",
  subtitle: "",
  heroTitleL1: "",
  heroTitleL2: "",
  explore: "Explore",
  featured: "Featured",
  views: "Views",
  empty: "No videos available",
  error: "Failed to load videos",
  retry: "Retry",
  end: "No more videos",
  exit: "Exit",
  muted: "Muted",
  sound: "Sound",
  share: "Share",
  seeMore: "See more",
  collapse: "Collapse",
  videoError: "Video unavailable",
  stillWatching: "Still watching?",
  continueWatching: "Continue watching",
  copied: "Link copied!",
  close: "Close",
  prev: "Previous",
  next: "Next",
  loginTitle: "Sign in to like",
  loginDesc: "Sign in to interact with this video",
  loginLater: "Later",
  loginNow: "Sign in",
};

const initialState = () =>
  Object.keys(KEYS).reduce((acc, name) => {
    acc[name] = DEFAULTS[name] || "";
    return acc;
  }, {});

export const useShortsTranslations = (lang) => {
  const [t, setT] = useState(initialState);

  const load = useCallback(async () => {
    if (!lang) return;
    const names = Object.keys(KEYS);
    const values = await Promise.all(names.map((name) => translate(KEYS[name], false)));
    const next = {};
    names.forEach((name, i) => {
      const val = values[i];
      next[name] = val && val !== KEYS[name] ? val : DEFAULTS[name] || "";
    });
    setT(next);
  }, [lang]);

  useEffect(() => {
    load();
  }, [lang, load]);

  return t;
};

export default useShortsTranslations;
